import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export type UserRole = 'admin' | 'user';

interface AuthState {
  userId: string | null;
  role: UserRole;
  token: string | null;
  isAuthenticated: boolean;
  setAuth: (userId: string, role: UserRole, token: string) => void;
  clearAuth: () => void;
  setRole: (role: UserRole) => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      userId: null,
      role: 'user',
      token: null,
      isAuthenticated: false,
      setAuth: (userId, role, token) => set({ 
        userId, 
        role, 
        token, 
        isAuthenticated: true 
      }),
      clearAuth: () => set({ 
        userId: null, 
        role: 'user', 
        token: null, 
        isAuthenticated: false 
      }),
      setRole: (role) => set({ role }),
    }),
    {
      name: 'farmpack-auth',
      storage: createJSONStorage(() => localStorage),
    }
  )
);